import i18next from 'i18next';
import { html } from 'lit-html';

const TemplateEmbedIndicatorsBilling = () => {
  return html` <div
    class="col-sm-12 col-xs-12 mypFacturacionWidgetView"
    id="mypFacturacionWidgetView"
  >
    <div id="spinner9" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div class="row">
      <div id="mypGraphic4" class="chari-chart aspect myp-aspect">
        <div
          id="mypNoDataRect4"
          class="esios-home__no-data-container_cuadrado hidden"
        >
          ${i18next.t('no-data-available')}
        </div>
      </div>
      <ul class="esios-listEnergyItems__list">
        <div class="row"></div>
      </ul>
    </div>

    <div class="col-xs-24 col-sm-24 mt-5"></div>
  </div>`;
};

export default TemplateEmbedIndicatorsBilling;
